import React from 'react';
import { Button, IconButton, TextField, FormControlLabel, Checkbox } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

const SplitReceiptDrawer = ({
  isSplitting,
  splits,
  splitNames,
  splitItems,
  splitTip,
  splitTax,
  selectedReceipt,
  splitColors,
  handleAddSplit,
  handleFinishSplit,
  setIsSplitting,
  handleSplitNameChange,
  handleSplitTipChange,
  handleSplitTaxChange,
}) => {
  const drawerHeight = '300px';

  return (
    <div 
      className="bg-gray-800 text-white transition-all duration-300 ease-out overflow-hidden fixed left-0 right-0 bottom-0"
      style={{
        height: drawerHeight,
        transform: isSplitting ? 'translateY(0)' : `translateY(${drawerHeight})`,
        transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
        opacity: isSplitting ? 1 : 0,
        pointerEvents: isSplitting ? 'auto' : 'none',
      }}
    >
      <div className="p-4 h-full flex flex-col">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
          <h3 className="text-xl font-bold mb-2 sm:mb-0">Split Receipt</h3>
          <div className="flex w-full sm:w-auto space-x-2">
            <Button
              onClick={handleAddSplit}
              variant="outlined"
              color="primary"
              startIcon={<AddIcon />}
              size="small"
              fullWidth
              className="sm:w-auto"
            >
              Add
            </Button>
            <Button
              onClick={handleFinishSplit}
              variant="contained"
              color="secondary"
              size="small"
              fullWidth
              className="sm:w-auto"
            >
              Finish
            </Button>
            <IconButton
              onClick={() => setIsSplitting(false)}
              className="text-white hover:text-gray-300"
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <div className="flex-grow overflow-x-auto overflow-y-hidden">
          <div className="flex pb-2">
            {splits.map((split, index) => (
              <div key={index} className="flex-shrink-0 w-24 mr-4 last:mr-0">
                <TextField
                  value={splitNames[index]}
                  onChange={(e) => handleSplitNameChange(index, e.target.value)}
                  variant="standard"
                  InputProps={{
                    style: { color: splitColors[index % splitColors.length], fontSize: '0.875rem', fontWeight: '600' }
                  }}
                  fullWidth
                  margin="dense"
                />
                <p className="text-sm">Subtotal: ${split.total.toFixed(2)}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-4">
          <FormControlLabel
            control={
              <Checkbox
                checked={splitTip}
                onChange={handleSplitTipChange}
                disabled={!selectedReceipt?.maybe_receipt_tip}
              />
            }
            label={
              <span>
                Split Tip
                {selectedReceipt?.maybe_receipt_tip && (
                  <span className="ml-2 text-sm text-gray-400">
                    (${(parseFloat(selectedReceipt.maybe_receipt_tip) / splits.length).toFixed(2)} each)
                  </span>
                )}
              </span>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={splitTax}
                onChange={handleSplitTaxChange}
                disabled={!selectedReceipt?.maybe_receipt_tax}
              />
            }
            label={
              <span>
                Split Tax
                {selectedReceipt?.maybe_receipt_tax && (
                  <span className="ml-2 text-sm text-gray-400">
                    (${(parseFloat(selectedReceipt.maybe_receipt_tax) / splits.length).toFixed(2)} each)
                  </span>
                )}
              </span>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default SplitReceiptDrawer;
